// extracted by mini-css-extract-plugin
export default {"value":"TransactionDetail_value__nT+3h","failed":"TransactionDetail_failed__eZWpw","skeletonLoadingAnimation":"TransactionDetail_skeletonLoadingAnimation__k1J0E"};